module.exports = __webpack_public_path__ + "static/media/tutor image.daefd6a2.svg";